var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgViewsEmpty = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#DFDFE0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_999_1962",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 76,
    height: 76
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37.6524,
    fill: "#F6F9FB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_999_1962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0088 39L23.0076 43L27.0088 39M22.5185 42C22.446 41.3433 22.4087 40.676 22.4087 40C22.4087 30.0589 30.4676 22 40.4087 22C50.3498 22 58.4087 30.0589 58.4087 40C58.4087 49.9411 50.3498 58 40.4087 58C34.7542 58 29.7086 55.3927 26.4087 51.3147M40.4087 30V40L45.2087 44.8",
    stroke: "white",
    strokeWidth: 3.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgViewsEmpty, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/views-empty.b872d771.svg";
export { ForwardRef as ReactComponent };